type ProviderOption = 'vimeo' | 'youtube'

interface ProviderConfig {
    provider: ProviderOption
    url: string
}

const PROVIDER_CONFIG: ProviderConfig[] = [
    {
        provider: 'vimeo',
        url: 'https://player.vimeo.com/',
    },
    {
        provider: 'youtube',
        url: 'https://www.youtube.com/embed/',
    },
    {
        provider: 'youtube',
        url: 'https://youtu.be/embed/',
    },
]

const getProviderConfig = (streamUrl: string): ProviderConfig | undefined => (
    streamUrl
    && PROVIDER_CONFIG.find(
        ({ url }) => streamUrl.startsWith(url)
    )
)

// https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url
const urlRegex = new RegExp('^(https?:\\/\\/)?' // protocol
    + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' // domain name
    + '((\\d{1,3}\\.){3}\\d{1,3}))' // OR ip (v4) address
    + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // port and path
    + '(\\?[;&a-z\\d%_.~+=-]*)?' // query string
    + '(\\#[-a-z\\d_]*)?$', 'i')
const isValidURL = (str: string) => urlRegex.test(str)

export const getIsValidEmbeddedUrl = (streamUrl: string) => (
    isValidURL(streamUrl) && !!getProviderConfig(streamUrl)
)

export const urlOptions = PROVIDER_CONFIG.map(({ url }) => url)
